import { autoTable } from 'jspdf-autotable';
import { Component, computed, OnInit } from '@angular/core';
import { faAngleDown, faAngleUp, faCalendar, faFilter } from '@fortawesome/free-solid-svg-icons';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { Chart, ChartConfiguration, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { CmdbDashboardService } from './service/cmdb-dashboard.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { LoadingNotificationService } from 'src/app/services/loading-notification/loading-notification.service';
import { ExcelService } from 'src/app/services/excel/excel.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { convertTo2DArray } from 'src/app/util/function/converter';
import { GlobalService } from 'src/app/services/global/global.service';
import {
	MspMultiCheckboxSelectComponent,
	MultiCheckboxSelectOption,
} from 'src/app/page_component_item/msp-multi-checkbox-select/msp-multi-checkbox-select.component';
import { CockpitChartService } from 'src/app/page/cockpit/cockpit-page/components/cockpit-chart/service/cockpit-chart.service';
import { cockpitChartInterface } from 'src/app/util/interfaces/cockpitRework/cockpitRework';
import { StatusCiTypeService } from 'src/app/page/register-page/register-forms/cmdb/status-ci-type/service/status-ci-type.service';
import { cmdbDashboardLocalidade } from './data/localidade.interface';
import { ToggleSwitchComponent } from 'src/app/page_component_item/toggle-switch/toggle-switch.component';
import { ToggleSwitchModule } from 'src/app/page_component_item/toggle-switch/toggle-switch.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule } from '@angular/common';
import { CollapseDirective } from 'src/app/util/directives/collapse/collapse.directive';
import { DateRangePickerComponent } from 'src/app/page_component_item/date-range-picker/date-range-picker.component';
import { CockpitChartModule } from '../../cockpit/cockpit-page/components/cockpit-chart/cockpit-chart.module';
import { SquarePostLoadingEffectComponent } from 'src/app/page_component_item/square-post-loading-effect/square-post-loading-effect.component';
import { DotBounceLoadingEffectComponent } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.component';
import { NgChartsModule } from 'ng2-charts';
import { DropdownBehaviourDirective } from 'src/app/util/directives/dropdownBehaviour/dropdown-behaviour.directive';
interface selectedValuesFilters {
	filterDate: 'today' | 'week' | 'month' | 'custom';
	location: string;
	ciType: string;
	subType: string;
	statuses: string[];
	showInactiveCis: boolean;
	showChartValues: boolean;
	customDate: string;
	ciTypesArray?: Array<{ ciType: number; subType: string }>;
	startDate?: string;
	endDate?: string;
}

@Component({
	standalone: true,
	imports: [
		ToggleSwitchModule,
		FontAwesomeModule,
		CommonModule,
		CollapseDirective,
		DateRangePickerComponent,
		MspMultiCheckboxSelectComponent,
		CockpitChartModule,
		SquarePostLoadingEffectComponent,
		DotBounceLoadingEffectComponent,
		NgChartsModule,
		DropdownBehaviourDirective,
	],
	selector: 'app-cmdb-dashboard',
	templateUrl: './cmdb-dashboard.component.html',
	styleUrls: ['./cmdb-dashboard.component.scss'],
})
export class CmdbDashboardComponent implements OnInit {
	icons = {
		faCalendar: faCalendar,
		faFilter: faFilter,
		faAngleUp: faAngleUp,
		faAngleDown: faAngleDown,
	};

	labels: LabelsInterface = {
		lbl_edocs_carregando: 'Loading',
		lbl_geral_dia: 'Dia',
		lbl_geral_semana: 'Semana',
		lbl_geral_mes: 'Mês',
		lbl_geral_todos: 'Todos',
		lbl_geral_exportar: 'Exportar',
		lbl_status_movimentacao_ativos: 'Status e movimentação de ativos',
		lbl_geral_movimentacoes_ativos_periodo_tempo: 'Movimentações de ativos por período de tempo',
		lbl_geral_movimentacoes: 'Movimentações',
		lbl_status_ci: 'Status Ci',
		lbl_geral_selecionados: 'Selecionados',
		lbl_geral_ativos_em_uso: 'Ativos em uso',
		lbl_geral_ativos_em_estoque: 'Ativos em estoque',
		lbl_geral_ativos_manutencao: 'Ativos em manutenção',
		lbl_asset_tipo_ci: 'Tipo CI',
		lbl_localidade: 'Localidade',
		lbl_mostrar_inativos: 'Mostrar inativos',
		lbl_geral_exibir_valores: 'Show Values',
	};

	isDatePickerOpen = false;
	isLoadingbarChartData = true;
	isLoadingKpiQtd = true;
	isLoadingCiIndicators = true;

	availableCiTypes: MultiCheckboxSelectOption[] = [];
	availableLocations: cmdbDashboardLocalidade[] = [];
	availableStatus: MultiCheckboxSelectOption[] = [];
	flowList: any[] = [];
	cmdbCockpitCards: cockpitChartInterface[] = [];
	cmdbCockpitCharts: cockpitChartInterface[] = [];
	darkMode = false;
	readonly cockpitChartConfig = {
		hideDelete: true,
		hideResize: true,
		defaultChartSize: 1,
	};

	collapseFilters = false;
	selectedValuesFilters: selectedValuesFilters = {
		filterDate: 'today',
		location: '',
		ciType: '',
		subType: '',
		statuses: [],
		showInactiveCis: false,
		showChartValues: true,
		customDate: '',
	};

	// Dados do gráfico
	barChartData: ChartConfiguration<'bar'>['data'] = {
		labels: [
			'00:00',
			'01:00',
			'02:00',
			'03:00',
			'04:00',
			'05:00',
			'06:00',
			'07:00',
			'08:00',
			'09:00',
			'10:00',
			'11:00',
			'12:00',
			'13:00',
			'14:00',
			'15:00',
			'16:00',
			'17:00',
			'18:00',
			'19:00',
			'20:00',
			'21:00',
			'22:00',
			'23:00',
		],
		datasets: [
			{
				data: [],
				label: '',
				backgroundColor: '',
			},
			{
				data: [],
				label: '',
				backgroundColor: '',
			},
		],
	};
	statuss: string[]; // Declaração adicionada para o status
	barChartOptions: ChartConfiguration<'bar'>['options'] = {
		responsive: true,
		maintainAspectRatio: false,
		plugins: {
			legend: {
				position: 'top',
				labels: {
					color: this.darkMode ? '#ffffff' : '#333333',
				},
			},
			datalabels: {
				anchor: 'center',
				align: 'center',
				offset: 0,
				display: (context) => {
					if (!this.selectedValuesFilters.showChartValues) {
						return false;
					}
					const dataset = context.chart.data.datasets[context.datasetIndex];
					const value = context.dataset.data[context.dataIndex] as number;
					return !dataset.hidden && value > 0 ? 'auto' : false;
				},
				formatter: (value, context) => {
					return Math.round(value);
				},
				color: '#fff',
				font: {
					weight: 'bold',
					size: 14,
				},
				backgroundColor: 'transparent',
				borderRadius: 4,
				padding: 4,
			},
		},
		scales: {
			x: {
				stacked: true,
				ticks: {
					autoSkip: true,
					maxTicksLimit: 12,
					maxRotation: 45,
					minRotation: 45,
					precision: 0,
					color: this.darkMode ? '#ffffff' : '#333333',
				},
			},
			y: {
				stacked: true,
				beginAtZero: true,
				ticks: {
					precision: 0,
					color: this.darkMode ? '#ffffff' : '#333333',
				},
			},
		},
	};

	constructor(
		private LabelsService: LabelsService,
		private CmdbDashboardService: CmdbDashboardService,
		private ProfileService: ProfileService,
		private LoadingNotificationService: LoadingNotificationService,
		private ExcelService: ExcelService,
		private NotificationService: NotificationService,
		private CockpitChartService: CockpitChartService,
		private StatusCiTypeService: StatusCiTypeService,
		public globalService: GlobalService
	) {
		// Registrar o plugin ChartDataLabels
		Chart.register(...registerables, ChartDataLabels);
		this.labels = computed(() => this.LabelsService.labels())();
	}

	teste(): void {
		console.log(this.cmdbCockpitCharts);
	}

	ngOnInit(): void {
		// Buscar tipos de CI disponíveis
		this.CmdbDashboardService.getAvailablesCiTypes().subscribe((ciTypesRes) => {
			const availableCiTypes: MultiCheckboxSelectOption[] = [];
			let lastType: MultiCheckboxSelectOption;

			for (const type of ciTypesRes) {
				const temporaryType: MultiCheckboxSelectOption = {
					value: type.subType?.toString() === '' ? type.ciType.toString() : type.subType.toString(),
					label: this.labels[type.type] || type.type,
					group_name: type.subType && type.subType.toString() != '' ? 'subtype' : 'type',
					emphasized: type.subType.toString() === '' || !type.subType,
					selected: false,
					children: [],
				};
				if (type.subType?.toString() === '') {
					availableCiTypes.push(temporaryType);
					lastType = temporaryType;
				} else {
					temporaryType.parent = lastType;
					lastType.children.push(temporaryType);
				}
			}

			this.availableCiTypes = availableCiTypes;
		});

		// Buscar localizações disponíveis
		this.CmdbDashboardService.getAvailablesLocations().subscribe((locationsRes) => {
			this.availableLocations = locationsRes;
		});

		this.StatusCiTypeService.getStatusCiType().subscribe((statusRes) => {
			this.availableStatus = statusRes.map((status) => {
				return {
					label: status.status,
					group_name: 'status',
					value: status.status,
					selected: false,
				};
			});
		});

		this.globalService.darkModeOn.subscribe((isDarkMode) => {
			this.darkMode = isDarkMode;
			this.updateChartColors();
		});

		const savedShowChartValues = localStorage.getItem('showChartValues');
		if (savedShowChartValues !== null) {
			this.selectedValuesFilters.showChartValues = savedShowChartValues === 'true';
		}

		this.filterValues();
	}

	triggerClearSelection = false;
	clearFilters(): void {
		this.selectedValuesFilters = {
			filterDate: 'today',
			location: '',
			ciType: '',
			subType: '',
			statuses: [],
			showInactiveCis: false,
			showChartValues: true,
			customDate: '',
		};
		this.triggerClearSelection = true;
		setTimeout(() => {
			this.triggerClearSelection = false;
		}, 0);
		this.filterValues();
	}

	filterValues(): void {
		this.isLoadingbarChartData = true;
		this.isLoadingKpiQtd = true;
		this.isLoadingCiIndicators = true;

		if (this.selectedValuesFilters.filterDate !== 'custom') {
			this.selectedValuesFilters.customDate = '';
			this.selectedValuesFilters.startDate = '';
			this.selectedValuesFilters.endDate = '';
		}

		// Buscar dados do gráfico de barras
		this.CmdbDashboardService.getDataChart(this.selectedValuesFilters).subscribe({
			next: (data) => {
				switch (this.selectedValuesFilters.filterDate) {
					case 'today':
					case 'week':
					case 'month': {
						this.barChartData = data;
						this.selectedValuesFilters.customDate = '';

						break;
					}

					case 'custom': {
						this.barChartData = data;

						break;
					}
					// No default
				}

				data.datasets[0].backgroundColor = this.ProfileService.getUserStylesheet()['primary-color-1'];
				data.datasets[1].backgroundColor = this.ProfileService.getUserStylesheet()['primary-color-2'];
				this.isLoadingbarChartData = false;
			},
			error: (error) => {
				console.error('Erro ao buscar dados do gráfico', error);
				this.barChartData = undefined;
				this.isLoadingbarChartData = false;
			},
		});

		// Buscar KPIs
		this.CmdbDashboardService.getListKpi(this.selectedValuesFilters).subscribe({
			next: (data) => {
				this.populateLists(data);
				this.isLoadingKpiQtd = false;
			},
			error: (error) => {
				console.error('Erro ao buscar dados do KPI', error);
				this.isLoadingKpiQtd = false;
			},
		});

		this.loadCiIndicators();
	}

	openDatePicker() {
		this.isDatePickerOpen = true;
	}

	selectDate(dateRange: string[]) {
		this.selectedValuesFilters.startDate = dateRange[0];
		this.selectedValuesFilters.endDate = dateRange[1];
		this.selectedValuesFilters.customDate = dateRange.map((date) => this.formatCustomDate(date)).join(' - ');
		this.selectedValuesFilters.filterDate = 'custom';
		this.filterValues();
		this.isDatePickerOpen = false;
	}

	private formatCustomDate(dateTime: string): string {
		const [date] = dateTime.split('T');
		const [year, month, day] = date.split('-');
		return `${day}/${month}/${year}`;
	}

	selectLocation(locationId: string) {
		this.selectedValuesFilters.location = locationId;
		this.filterValues();
	}

	toggleInactiveCis(value: boolean) {
		this.selectedValuesFilters.showInactiveCis = value;
		this.filterValues();
	}

	handleCiTypeSelection(selectedValues: MultiCheckboxSelectOption[]) {
		let ciTypeString = '';
		let subTypeString = '';
		for (const ciType of selectedValues) {
			if (ciType.group_name === 'subtype') {
				ciTypeString += ciType.parent?.value + ', ';
				subTypeString += ciType.value + ', ';
			}
			if (ciType.group_name === 'type') {
				ciTypeString += ciType.value + ', ';
			}
		}
		this.selectedValuesFilters.ciType = ciTypeString.slice(0, -2);
		this.selectedValuesFilters.subType = subTypeString.slice(0, -2);
		this.filterValues();
	}

	handleStatusSelection(selectedValues: MultiCheckboxSelectOption[]) {
		this.selectedValuesFilters.statuses = selectedValues.map((item) => item.value);
		this.filterValues();
	}

	toggleChartValues(value: boolean) {
		this.selectedValuesFilters.showChartValues = value;
		localStorage.setItem('showChartValues', value.toString());
		this.barChartData = { ...this.barChartData };
	}

	updateChartColors(): void {
		if (this.barChartOptions && this.barChartOptions.plugins && this.barChartOptions.scales) {
			// legenda
			if (this.barChartOptions.plugins.legend && this.barChartOptions.plugins.legend.labels) {
				this.barChartOptions.plugins.legend.labels.color = this.darkMode ? '#ffffff' : '#333333';
			}

			// eeixos
			if (this.barChartOptions.scales.x && this.barChartOptions.scales.x.ticks) {
				this.barChartOptions.scales.x.ticks.color = this.darkMode ? '#ffffff' : '#333333';
			}
			if (this.barChartOptions.scales.y && this.barChartOptions.scales.y.ticks) {
				this.barChartOptions.scales.y.ticks.color = this.darkMode ? '#ffffff' : '#333333';
			}

			this.barChartData = { ...this.barChartData };
		}
	}

	private loadCiIndicators(): void {
		this.CockpitChartService.getCockpitByFilters({
			family: 'cmdb',
			period_type: this.selectedValuesFilters.filterDate,
			location: this.selectedValuesFilters.location,
			statuses: this.selectedValuesFilters.statuses,
			showInactiveCis: this.selectedValuesFilters.showInactiveCis,
			ciType: this.selectedValuesFilters.ciType,
			subType: this.selectedValuesFilters.subType,
			ciTypesArray: this.selectedValuesFilters.ciTypesArray || [],
			startDate: this.selectedValuesFilters.startDate,
			endDate: this.selectedValuesFilters.endDate,
		}).subscribe({
			next: (charts) => {
				const cmdbIndicators = (charts || []).filter((chart) => chart.family === 'cmdb' && chart.title !== 'flow_cmdb');
				this.cmdbCockpitCards = cmdbIndicators.filter((chart) => chart.type === 'text');
				this.cmdbCockpitCharts = cmdbIndicators.filter((chart) => chart.type !== 'text');
				this.isLoadingCiIndicators = false;
			},
			error: (error) => {
				console.error('Erro ao buscar indicadores de CI do cockpit', error);
				this.cmdbCockpitCards = [];
				this.cmdbCockpitCharts = [];
				this.isLoadingCiIndicators = false;
			},
		});
	}

	populateLists(data: any): void {
		if (data && data.flow) {
			this.flowList = Object.values(data.flow);
		} else {
			// Fallback com dados mockados caso o backend não retorne dados
			this.flowList = [
				{ label: 'lbl_geral_ativos_em_uso', quantity: 0 },
				{ label: 'lbl_geral_ativos_em_estoque', quantity: 0 },
				{ label: 'lbl_geral_ativos_manutencao', quantity: 0 },
			];
		}
	}

	exportData() {
		const idNotificaton = this.LoadingNotificationService.setNotificationMessage(
			`Dashboard CMDB - ${this.labels.lbl_geral_exportar}`,
			'loading',
			'faFileAlt'
		);
		setTimeout(() => {
			this.CmdbDashboardService.exportData(this.selectedValuesFilters).subscribe(
				(resp) => {
					this.LoadingNotificationService.updateNotificationStatus(idNotificaton, 'success');
					return this.ExcelService.exportAsExcelFile(resp, 'Relatório CMDB');
				},
				(error) => {
					console.error('Ocorreu um erro ao exportar os dados:', error);
					this.LoadingNotificationService.updateNotificationStatus(idNotificaton, 'error');
				}
			);
		}, 5);
	}

	exportDataMoviments() {
		const idNotificaton = this.LoadingNotificationService.setNotificationMessage(
			`Dashboard CMDB - ${this.labels.lbl_geral_movimentacoes}`,
			'loading',
			'faFileAlt'
		);
		setTimeout(() => {
			this.CmdbDashboardService.exportMovements(this.selectedValuesFilters).subscribe(
				(resp) => {
					if (!resp || (Array.isArray(resp) && resp.length === 0)) {
						this.NotificationService.setNotificationMessage('Não há movimentações para os filtros selecionados');
						this.LoadingNotificationService.updateNotificationStatus(idNotificaton, 'attention');
						return;
					}
					this.LoadingNotificationService.updateNotificationStatus(idNotificaton, 'success');
					const movementHeaders = [
						this.labels.lbl_geral_id,
						this.labels.lbl_geral_identificacao,
						this.labels.lbl_asset_numero_serie,
						this.labels.lbl_asset_tipo_ci,
						this.labels.lbl_geral_subtipo,
						this.labels.lbl_asset_fabricante,
						this.labels.lbl_geral_modelo,
						this.labels.lbl_geral_movement_date,
						this.labels.lbl_geral_tipo_movimentacao,
						`${this.labels.lbl_geral_localidade} (origem)`,
						`${this.labels.lbl_geral_localidade} (destino)`,
						this.labels.lbl_geral_ultima_atualizacao,
					];
					const array2d = convertTo2DArray(resp, movementHeaders);
					return this.ExcelService.exportAsExcelFile(array2d, `Relatório CMDB - ${this.labels.lbl_geral_movimentacoes}`);
				},
				(error) => {
					console.error('Ocorreu um erro ao exportar os dados:', error);
					this.LoadingNotificationService.updateNotificationStatus(idNotificaton, 'error');
				}
			);
		}, 5);
	}
}
